import React, { useState, useEffect, useRef } from 'react';
import { LiaShoppingCartSolid } from "react-icons/lia";
import { connect } from 'react-redux';
import { MdClose } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import CartChecklist from '../CartChecklist';
import CartItem from '../CartItem';
import styles from './CartDrawer.module.css';

// Carrito lateral del catálogo. Panel bajo el navbar, sin fondo oscuro: con el carrito abierto se
// pueden seguir agregando productos. Se abre y cierra con el botón del carrito, la ✕ o Escape.
const CartDrawer = ({ carrito }) => {
  const [productos, setProductos] = useState([]);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [showCheckList, setShowCheckList] = useState(false);
  const closeButtonRef = useRef(null);
  const items = carrito.items;
  useEffect(() => {
    if (items) {
      setProductos(items);
    }
  }, [items]);

  useEffect(() => {
    if (!open) return undefined;
    closeButtonRef.current?.focus();
    const handleKeyDown = (event) => {
      // Escape del checklist de confirmación lo maneja el checklist
      if (event.key === 'Escape' && !showCheckList) setOpen(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, showCheckList]);

  const mostrarCheckList = () => {
    setShowCheckList(true);
  };

  const isCarroProductosPage = location.pathname === "/carroproductos";

  const isConfirmButtonDisabled = productos.length === 0;
  const countLabel = `${productos.length} ${productos.length === 1 ? 'producto' : 'productos'}`;

  return (
    <>
      {isCarroProductosPage && (
        <button
          type="button"
          className={styles.cartButton}
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls="cart-drawer"
          aria-label={`Carrito, ${countLabel}`}
        >
          <LiaShoppingCartSolid size={26} aria-hidden="true" />
          {productos.length > 0 && (
            <span className={styles.cartItemCount} aria-hidden="true">{productos.length}</span>
          )}
        </button>
      )}
      {open && (
        <aside id="cart-drawer" className={styles.cart} aria-label="Carrito">
          <header className={styles.header}>
            <div>
              <h2 className={styles.title}>Tu solicitud</h2>
              <p className={styles.subtitle}>{countLabel}</p>
            </div>
            <button
              type="button"
              ref={closeButtonRef}
              className={styles.closeButton}
              onClick={() => setOpen(false)}
              aria-label="Cerrar carrito"
            >
              <MdClose aria-hidden="true" />
            </button>
          </header>
          {productos.length > 0 ? (
            <ul className={styles.list}>
              {productos.map((producto) => (
                <CartItem
                  key={producto.producto.id}
                  producto={producto}
                  itemsCarrito={carrito.items}
                />
              ))}
            </ul>
          ) : (
            <p className={styles.empty}>Aún no agregas productos a la solicitud.</p>
          )}
          <footer className={styles.footer}>
            <button
              type="button"
              className={styles.confirmButton}
              onClick={mostrarCheckList}
              disabled={isConfirmButtonDisabled}
            >
              Confirmar solicitud
            </button>
          </footer>
        </aside>
      )}
      <CartChecklist mostrarCheckList={showCheckList} setMostrarCheckList={setShowCheckList} />
    </>
  );
};

const mapStateToProps = state => ({
  carrito: state.Solicitud.carrito,
  solicitud: state.Solicitud
});

export default connect(mapStateToProps)(CartDrawer);
